import { render, staticRenderFns } from "./NavigationBetaButton.vue?vue&type=template&id=610109d3&"
import script from "./NavigationBetaButton.vue?vue&type=script&lang=ts&"
export * from "./NavigationBetaButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports